import { ReactComponent as ExpandIcon } from './expand.svg';

export default ExpandIcon;
